import { Stack } from '@mui/material'
import {
  AlternateEmail,
  PermContactCalendar,
  Person,
  Phone,
  School,
  Settings,
  Star,
} from '@mui/icons-material'
import { User } from '../../store/types'
import { t } from 'i18next'
import DetailsTile from '../../components/Tile/DetailsTile'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import { getSidebarState } from '../../store/redux/reducers/sidebarSlice'
import DateFormat from '../../store/types/enums/DateFormat'

type ProfileDescriptionProps = {
  user: User | null
}

const ProfileDescription = ({ user }: ProfileDescriptionProps) => {
  const isSidebarOpen = useSelector(getSidebarState)
  return (
    <Stack gap={2} direction={{ xs: 'column', smMid: 'row', md: isSidebarOpen ? 'row' : 'column', lg: 'column' }}>
      <Stack gap={2} width={{ xs: '100%', smMid: '50%', md: '100%' }}>
        <DetailsTile
          title={t('page.usersProfile.tiles.fullName')}
          description={user ? `${user.firstName} ${user.lastName}` : '-'}
          icon={<Person />}
        />

        <DetailsTile
          title={t('page.usersProfile.tiles.email')}
          description={user ? `${user.email}` : '-'}
          icon={<AlternateEmail />}
        />

        <DetailsTile
          title={t('page.usersProfile.tiles.phone')}
          description={user && user.phoneNumber ? `${user.phoneNumber}` : '-'}
          icon={<Phone />}
        />

        <DetailsTile
          title={t('page.usersProfile.tiles.birthDate')}
          description={user && user.birthDate ? `${dayjs(user.birthDate).format(DateFormat.DayMonthYear)}` : '-'}
          icon={<PermContactCalendar />}
        />

        <DetailsTile
          title={t('page.usersProfile.tiles.status')}
          description={user ? t(`page.usersProfile.statuses.${user.employeeStatus}`) : '-'}
          icon={<Settings />}
        />
      </Stack>

      <Stack gap={2} width={{ xs: '100%', smMid: '50%', md: '100%' }}>
        <DetailsTile
          title={t('page.usersProfile.tiles.isStudent')}
          description={user ? (user.student ? t('page.usersProfile.yes') : t('page.usersProfile.no')) : '-'}
          icon={<School />}
        />

        <DetailsTile
          title={t('page.usersProfile.tiles.leader')}
          description={
            user && user.leaders && user.leaders.length > 0
              ? user.leaders.map(leader => `${leader.firstName} ${leader.lastName}`).join(', ')
              : '-'
          }
          icon={<Star />}
        />
      </Stack>
    </Stack>
  )
}

export default ProfileDescription